<template>
  <v-app-bar color="background" dense elevation="0" max-height="50">
    <v-toolbar-title>
      <v-img :src="require('@/assets/Logo DVA Tools.svg')" contain max-height="30" />
    </v-toolbar-title>
    <v-spacer />
    <v-tabs v-if="!isMobile" color="white" dark v-model="currentTab" background-color="transparent" right hide-slider>
      <v-tab v-for="tab in tabs" :key="tab.id" :to="tab.route" exact>{{ tab.name }}</v-tab>
    </v-tabs>
    <v-menu offset-y v-else rounded="lg" nudge-bottom="5">
      <template #activator="{ on, attrs }">
        <v-btn icon class="ma-2" v-on="on" v-bind="attrs" id="app-bar-menu">
          <v-icon color="white">mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="tab in tabs" :key="tab.id" :to="tab.route" exact>
          <v-list-item-icon>
            <v-icon>{{ tab.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ tab.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
/* eslint-disable object-curly-newline */
export default {
  name: "AppBar",
  data() {
    return {
      currentTab: "/",
      tabs: [
        { id: "home", icon: "mdi-chart-line", name: this.$i18n.t("appbar.home"), route: { name: "home" } },
        { id: "rankings", icon: "mdi-format-list-bulleted", name: this.$i18n.t("appbar.rankings"), route: { name: "rankings" } },
      ],
    };
  },
  computed: {
    isMobile() {
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
        return true;
      }
      return false;
    },
  },
  methods: {
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      });
    },
  },
};
</script>

<style scoped></style>
